import { HomeScreen } from '@strata/react-page-templates';

import { AppRoutes } from 'services/routes';
import { useGetHomeScreenMessagesQuery } from 'store/api/announcementApi';

export const Home = () => {
    const { data: messages } = useGetHomeScreenMessagesQuery();

    return (
        <HomeScreen
            illustration={HomeScreen.Illustration.AGORA}
            button={{ label: 'View Referrals', path: AppRoutes.referralsList }}
            welcomeMessagePartOne="With Free Market Health's Agora Monitoring Application, you can now view a referral's journey in real time. Dynamically aligned with our backend services, Agora is revolutionizing the visibility process as we know it."
            welcomeMessagePartTwo="At the center of it all is our data, which needs visibility. Agora is part of Free Market Health's transparent process that aligns the priorities of team members, for the health of all."
            messages={messages}
            viewAllUpdatesUrl={AppRoutes.updatesHistory}
        />
    );
};
